const mediaQ = (size: number): string => `@media only screen and (min-width: ${size}px)`;

export const colors = {
    primary: '#1E7A45',
    primaryWhite: '#fff',
    primaryGray: '#E9EBEE',
    lightGray: '#fafafb',
    borderGray: '#BDC7D8',
    antdBorder: '#E8E8E8',
    secondaryColor: '#242C38',
    semiTransparentBlack: 'rgba(0,0,0,.25)',
    contentShadow: '0 0.3rem 1.2rem rgba(0, 0, 0, 0.19), 0 0.4rem 0.4rem rgba(0, 0, 0, 0.23)',
    antdErrorText: '#f5222d',
    antdSelection: '#f0fcff',
    disabled: '#c5c5c5',
    default: 'default',
    red: '#ca3a2a',
    green: '#2aca67',
    yellow: '#cab22a',
};

export const fontSizes = {
    extraSmall: '0.6rem',
    small: '1rem',
    medium: '1.2rem',
    large: '1.4rem',
    extraLarge: '1.6rem',
};

export const fontWeights = {
    bold: 700,
    medium: 500,
};

export const iconSizes = {
    small: '0.7rem',
    medium: '1.2rem',
    large: '1.6rem',
    extraLarge: '3.6rem',
};

export const breakpointsValues = {
    small: 576,
    medium: 743,
    large: 920,
    desktop: 1200,
    extraLarge: 1460,
};

export const breakpoints = {
    small: mediaQ(breakpointsValues.small),
    medium: mediaQ(breakpointsValues.medium),
    large: mediaQ(breakpointsValues.large),
    desktop: mediaQ(breakpointsValues.desktop),
    extraLarge: mediaQ(breakpointsValues.extraLarge),
};

export const borders = {
    border: `1px solid ${colors.borderGray}`,
    radius: '5px',
    mediumRadius: '15px',
};

export const sizes = {
    formWidth: '1100px',
    pageHeader: '64px',
    pageHeaderSmall: '40px',
};

/* Design Brief Option B v4 palette — bottle green + warm neutrals + gold accent.
   Used by the modernised UI components (Auth, FilterDrawer, StatusPill, BenefitIcon,
   ProjectIcon, GoldButton, etc.). */
export const palette = {
    /* Brand greens */
    bottle: '#132B1C',
    canopy: '#1A3A24',
    forest: '#1E7A45',
    fern: '#176338',
    sage: '#A8C9A8',
    sageLt: '#E2F0E2',
    lime: '#7FBE3D',
    limeLt: '#E5F4D0',

    /* Gold accent (used for "+ Add" CTAs) */
    gold: '#D4A520',
    goldLt: '#F4E4A8',

    /* Warm neutrals */
    warmBg: '#F7F4EE',
    warm100: '#EDE8DA',
    warm200: '#D9D3C2',
    warm400: '#8B8275',
    warm700: '#3D3A35',

    /* Status */
    ragRed: '#B83232',
};
